/*------------------------------------------------
// File Name:PDM_KeFu.js
// File Description:PDM_KeFu store方法
// Author:zxl
// Create Time:2023/09/15 17:07:45
//------------------------------------------------*/

import {
    GetPDM_KeFuList,
    GetPDM_KeFuListByPage,
    GetPDM_KeFuEntity,
    CreatePDM_KeFuEntity,
    UpdatePDM_KeFuEntity,
    DeletePDM_KeFuEntity,
} from '@/api/pdm/kefu'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmKefu = {
    namespaced: true,
    state: {
        PdmKefuList: [],
        PdmKefuListLoading: false,
        PdmKefuEntity: null,
        PdmKefuShowDlg: false,
    },
    mutations: {
        setPdmKefuList(state, dataList) {
            state.PdmKefuList = [...dataList]
        },
        setPdmKefuListLoading(state, visible) {
            state.PdmKefuListLoading = visible
        },
        setPdmKefuShowDlg(state, visible) {
            state.PdmKefuShowDlg = visible
        },
        setPdmKefuEntity(state, entity) {
            state.PdmKefuEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmKefu({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_KeFuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmKefuEntity', res.Data)
                        commit('setPdmKefuShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmKefuEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmKefuListLoading', true)
                GetPDM_KeFuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmKefuEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmKefuListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmKefuList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmKefuListLoading', true)
                GetPDM_KeFuList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmKefuList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmKefuListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmKefuListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmKefuListLoading', true)
                GetPDM_KeFuListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmKefuList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmKefuListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmKefu({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_KeFuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmKefuShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_KeFu
        actEditPdmKefuData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmKefuID : entity.PdmKefuID
                }
                GetPDM_KeFuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmKefuEntity', res.Data)
                        commit('setPdmKefuShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_KeFu ,传对象过来
        actEditPdmKefu({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmKefuEntity', entity)
                commit('setPdmKefuShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_KeFu
        actDeletePdmKefu({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_KeFuEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmKefuShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


